// Logo URLs - local paths
export const BAILA_LOGO = "/images/branding/baila-logo-white.png";
export const BUNNY_LOGO = "/images/branding/bunny-logo.png";
export const BUNNY_GLASSES = "/images/branding/bunny-glasses.png";

// Pixel IDs
export const META_PIXEL_ID = '179511642577064';
export const TIKTOK_PIXEL_ID = 'C189G8RC77UBJAEBRS80';
// GTM-M3Z7P43H is the Web container for bailadembow.com (Baila Dembow account).
// Two other containers exist and are NOT this one: GTM-PJRVC7CQ ("Baila Server")
// is a server-side container, and GTM-TJSSP3R lives under a separate
// "EventixGTM" account — neither belongs in this site's HTML.
export const GTM_CONTAINER_ID = 'GTM-M3Z7P43H';

// Link-preview ("Open Graph") card used when a page has no card of its own.
// Evergreen on purpose (site hero + logo) so it can't go stale like a poster.
// Per-event cards (og_image on an event, 1200x630 JPEG) are generated by
// scripts/make-og-images.py. Link scrapers don't run JS, so these must be real
// files on this domain, not a raw 2MB poster.
export const DEFAULT_OG_IMAGE = "/images/og/og-default.jpg";

// Cookie consent storage key
export const CONSENT_KEY = 'baila_cookie_consent';

// YouTube video
export const YOUTUBE_VIDEO_ID = "wnHQetmyGHQ";

// Gallery images for the Experience section
export const GALLERY_IMAGES = [
  { id: "gallery-1", url: "/gallery/gallery1.jpg", alt: "Baila Dembow event crowd" },
  { id: "gallery-2", url: "/gallery/gallery2.jpg", alt: "Baila Dembow party atmosphere" },
  { id: "gallery-3", url: "/gallery/gallery3.jpg", alt: "Baila Dembow dance floor" },
  { id: "gallery-4", url: "/gallery/gallery4.jpg", alt: "Baila Dembow event energy" },
  { id: "gallery-5", url: "/gallery/gallery5.jpg", alt: "Baila Dembow club night" },
  { id: "gallery-6", url: "/gallery/gallery6.jpg", alt: "Baila Dembow Latin vibes" },
  { id: "gallery-7", url: "/gallery/gallery7.jpg", alt: "Baila Dembow crowd experience" },
  { id: "gallery-8", url: "/gallery/gallery8.jpg", alt: "Baila Dembow party scene" }
];

// Events data (static)
// History:
//   2026-06-08 — Rotterdam (06 Jun) + PADELDAM (07 Jun) removed (past)
//   2026-06-18 — Den Haag (13 Jun) + Coffee Day Rave (14 Jun) removed (past)
//   2026-06-18 — July 2026 agenda added: Rotterdam, Leiden, Amsterdam, Groningen
//   2026-07-17 — Past July events removed (Rotterdam 04, IJland 05, Leiden 11); Rotterdam Reverse Summer Special (01 Aug) added
//   2026-07-18 — Amsterdam Oliva (18 Jul) removed; Supper Club (07 Aug) + Summer of Love XL (29 Aug) added
//   2026-07-27 — Groningen (25 Jul) removed (past). Live: Rotterdam 01 Aug, Supper Club 07 Aug, Summer of Love 29 Aug
//   2026-08-11 — Supper Club (07 Aug) removed (past). customSlug added so /events/<slug> URLs match the sitemap.
//   2026-08-26 — Groningen All White Edition (22 Aug) removed (past)
//   2026-09-01 — Summer of Love XL (29 Aug) removed (past)
//   2026-09-01 — Groningen (10 Oct, Huize Maas) added
//   2026-09-07 — Rotterdam Club Reverse (5 Sep) removed (past)
//   2026-09-11 — Leiden (23 Oct, Wibar) added
//   2026-09-21 — Den Haag Westwood (12 Sep) removed (past)
//   2026-09-21 — Rotterdam All White (3 Oct, Club Reverse) added
//   2026-10-05 — Amsterdam Oliva (26 Sep), Eindhoven (2 Oct), Rotterdam All White
//                (3 Oct) removed (past)
//   2026-10-12 — Groningen Huize Maas (10 Oct) removed (past)
//   2026-10-16 — Rotterdam Día de Muertos (7 Nov, Club Reverse) added (live with the final poster)
//   2026-10-22 — Groningen (12 Dec, Huize Maas) added
//   2026-10-25 — Leiden Wibar (23 Oct) removed (past); Amsterdam Supperclub round two (28 Nov) added
//   2026-10-25 — Den Haag Westwood (21 Nov) added
//   2026-10-28 — Indoor Fest NYE at IJLAND (31 Dec) added as the primary spotlight (featured_priority 1);
//                Halloween becomes the secondary spotlight (featured_priority 2)
//   2026-10-29 — Halloween (31 Oct) marked SOLD OUT (sold_out flag, sold-out poster, 2027 signup CTA)
//   Keep EVENTS in date order (pages also sort by date when rendering).
//
// The /events/PadelXReggaeton standalone route still exists in App.js for
// any inbound bookmarks but is no longer linked from the grid.
export const EVENTS = [
  {
    id: "ijland-halloween-oct31-2026",
    customSlug: "halloween-31-october-2026",
    city: "Amsterdam",
    venue: "IJLAND, TT Vasumweg 171, Amsterdam",
    date: "2026-10-31",
    time: "23:00 – 05:00",
    title: "THE AMSTERDAM LATIN HALLOWEEN FESTIVAL",
    featured: true,
    featured_priority: 2,          // secondary spotlight on the homepage (NYE is primary)
    dress_code: "Scary, Sexy or Scary-Sexy",
    tagline: "The nightmare wakes up all over again.",
    landing_page: "/halloween",
    og_image: "/images/og/og-halloween.jpg",
    teaser_video: "/videos/halloween-teaser.mp4",
    // Urgency messaging shown on the homepage spotlight and the /halloween
    // page. price_deadline is the last day of the current price tier (shown
    // as "price rises after"). Ticket-sales figures are deliberately NOT
    // published on the site: sales numbers stay private to the owner.
    price_deadline: "2026-10-15",
    price_deadline_label: "15 October",
    description: "SOLD OUT. No more tickets are available for this edition. If you still want to come, only buy from a reputable reseller such as TicketSwap and be aware of fake tickets: never pay strangers by bank transfer. Early-release tickets for Halloween 2027 go first to the people on the list: sign up at bailadembow.com/halloween/2027. The nightmare wakes up all over again. On Saturday, October 31st, the gates of IJLAND swing open one more time and the whole venue turns into a haunted inferno. Last edition we packed the room wall to wall, and this year the creatures crawl back thirstier for blood than ever. Vampires, ghouls, zombies and restless spirits take over every dark corner while our Baila Dembow DJs run reggaeton, dembow, Latin and Caribbean heat with zero breaks until the sun comes up. Bad Bunny, Karol G, El Alfa, Rauw Alejandro, Daddy Yankee and more shake the walls straight through the night. The capital of the Netherlands will not feel the same after this one. What to expect: cash prize for the best costume of the night · full haunted club transformation · free trick and treat sweets · spooky photobooth for the crew · costumes everywhere you look · Latin and Caribbean energy on full blast · 2 areas · food trucks on site · y mucho más. 📍 Location: IJLAND, TT Vasumweg 171, Amsterdam · 🗓️ Date: Saturday, October 31, 2026 · ⏰ Time: 23:00 to 05:00 · 🔞 18+ event, ID required · 👗 Dress code: Scary, Sexy or Scary-Sexy. Music: Reggaeton, Dembow, Dancehall, Salsa, Bachata, Merengue. Come in costume, come correct, and do not be the one hearing about it on Sunday.",
    ticket_url: "https://weeztix.shop/nxaqrkdz",
    // 2026-10-29 — SOLD OUT. Every ticket CTA for this event renders <SoldOutCta/> (reseller warning +
    // link to the /halloween/2027 early-release signup) instead of the Weeztix link. ticket_url is kept
    // only for the structured-data offer URL.
    sold_out: true,
    status: "sold_out",
    price_from: "",
    price_door: "",
    image_url: "/images/events/halloween-ijland-oct31-2026-soldout.jpg"
  },
  {
    id: "rotterdam-reverse-muertos-nov7-2026",
    customSlug: "dia-de-los-muertos-rotterdam-7-november-2026",
    city: "Rotterdam",
    venue: "Club Reverse, Rotterdam",
    date: "2026-11-07",
    time: "23:00 – 05:00",
    title: "DÍA DE MUERTOS // ROTTERDAM",
    tagline: "Los muertos vuelven a bailar.",
    og_image: "/images/og/og-muertos-rotterdam.jpg",
    dress_code: "Face paint, flowers, catrina or catrín look — optional",
    description: "¡ROTTERDAM, LOS MUERTOS VUELVEN A BAILAR! 💀🌼 Rotterdam, get your crew ready. We’re bringing a little Mexico to Reverse! 🇲🇽🔥 On Saturday, November 7, Baila Dembow celebrates Día de los Muertos with colourful flowers, sugar skulls and a whole lot of perreo. It’s a celebration of life, love and the people we miss. And we’re celebrating the way we know best: together, on the dance floor. ❤️ Expect reggaeton, dembow, Latin hits, salsa and bachata all night. Bad Bunny, Karol G, El Alfa, Romeo Santos… you know what’s coming. Come sing your heart out and dance with us till 05:00. 💀 Face paint? Yes. Flowers? Yes. Full catrina or catrín look? We love it. Dress up if you feel like it, or just come ready to dance. Drop this in the group chat. Pick your look. Let’s make a night of it. 🔥 📍 Location: Club Reverse, Rotterdam · 🗓️ Date: Saturday, November 7, 2026 · ⏰ Time: 23:00 – 05:00 · 🔞 18+ event, ID required. 🎟️ Early birds get the best price. Tickets go up with each release, so grab yours early! Nos vemos en la pista 🐇",
    ticket_url: "https://weeztix.shop/5yvdx32r",
    status: "upcoming",
    price_from: "",
    price_door: "",
    image_url: "/images/events/rotterdam-reverse-muertos-nov7-2026.png"
  },
  {
    id: "denhaag-westwood-nov21-2026",
    customSlug: "den-haag-21-november-2026",
    city: "Den Haag",
    venue: "Westwood, Laan van Poot 7, 2566 EV Den Haag",
    date: "2026-11-21",
    time: "23:00 – 04:00",
    title: "BAILA DEMBOW // DEN HAAG",
    tagline: "Volvemos a Westwood.",
    og_image: "/images/og/og-denhaag-nov21.jpg",
    description: "¡DEN HAAG, VOLVEMOS A WESTWOOD! Baila Dembow is the Latin Caribbean club night that’s been filling dance floors across the Netherlands and London since 2019. It started with a simple idea: play the music that makes people move, loud and without breaks, for a crowd that comes to dance from the very first track. Students, expats, Latinos missing home and Dutch locals who just love the sound all end up on the same floor, and that mix is what makes the night feel the way it does. On Saturday, November 21st we’re back at Westwood with reggaeton, dembow, Latin hits and more until 04:00. Think Bad Bunny, Karol G, El Alfa, Rauw Alejandro and Daddy Yankee, mixed with the dembow that keeps the perreo going all night. If you were here last time, you already know what this room turns into. If you weren’t, this is the one to start with. Early bird tickets are the cheapest way in, and every tier after that costs a bit more. Grab yours now so you’re not paying extra at the door, and bring your crew with you. 📍 Location: Westwood, Laan van Poot 7, Den Haag · 🗓️ Date: Saturday, November 21, 2026 · ⏰ Time: 23:00 till 04:00 · 🚪 Last entry: 03:00 · 🔞 18+ event, ID required.",
    ticket_url: "https://weeztix.shop/z9xgcjv6",
    status: "upcoming",
    price_from: "",
    price_door: "",
    image_url: "/images/events/denhaag-westwood-nov21-2026.png"
  },
  {
    id: "amsterdam-supperclub-nov28-2026",
    customSlug: "amsterdam-supperclub-28-november-2026",
    city: "Amsterdam",
    venue: "Supperclub, Singel 460, Amsterdam",
    date: "2026-11-28",
    time: "23:30 – 05:00",
    title: "BAILA DEMBOW // AMSTERDAM",
    tagline: "Volvemos a Supperclub. Round two.",
    og_image: "/images/og/og-supperclub-nov28.jpg",
    description: "¡AMSTERDAM, VOLVEMOS A SUPPERCLUB! In August we brought Baila Dembow to Supperclub for the first time and the room was packed wall to wall. Every inch of that floor was moving, and nobody wanted the lights to come on. On Saturday, November 28th we go back for round two with reggaeton, dembow, Latin hits and nonstop perreo until 05:00. 🎶 Bad Bunny, Karol G, El Alfa, Rauw Alejandro and more 🪩 Supperclub, round two. If you missed August, you heard all about it afterwards, and you don’t want that feeling again. Early bird tickets are live now and they’re the cheapest way in. Once they’re gone the price only goes up, so lock yours in before your group chat starts asking. 📍 Location: Supperclub, Singel 460, Amsterdam · 🗓️ Date: Saturday, November 28, 2026 · ⏰ Time: 23:30 till 05:00 · 🔞 18+ event, ID required.",
    ticket_url: "https://weeztix.shop/rw9qseqg",
    status: "upcoming",
    price_from: "",
    price_door: "",
    image_url: "/images/events/amsterdam-supperclub-nov28-2026.png"
  },
  {
    id: "groningen-huizemaas-dec12-2026",
    customSlug: "groningen-12-december-2026",
    city: "Groningen",
    venue: "Huize Maas, Groningen",
    date: "2026-12-12",
    time: "23:00 – 04:00",
    title: "BAILA DEMBOW // GRONINGEN",
    tagline: "Cerramos el año juntos.",
    og_image: "/images/og/og-groningen-dec12.jpg",
    description: "¡GRONINGEN, CERRAMOS EL AÑO JUNTOS! Groningen has had our back all year at Huize Maas, and every night we’ve played there has given us another reason to come back. On Saturday, December 12 we return for the final Baila Dembow in Groningen this year, and we want to close 2026 the way it deserves. Five hours of reggaeton, dembow and Latin Caribbean hits, with Bad Bunny, Karol G, El Alfa and Rauw Alejandro on heavy rotation and the perreo going from the first track until the lights come on. Early bird tickets are live right now and they’re the cheapest way in. Every round that sells out pushes the price up, and December weekends fill quickly once everyone’s end-of-year plans start stacking up. Get yours early, keep a few extra euros for the bar, and get your whole crew sorted before the price moves. 📍 Location: Huize Maas, Groningen · 🗓️ Date: Saturday, December 12, 2026 · ⏰ Time: 23:00 till 04:00 · 🔞 18+ event, ID required.",
    ticket_url: "https://weeztix.shop/n9q3madk",
    status: "upcoming",
    price_from: "",
    price_door: "",
    image_url: "/images/events/groningen-huizemaas-dec12-2026.png"
  },
  {
    id: "ijland-nye-dec31-2026",
    customSlug: "nye-amsterdam-31-december-2026",
    city: "Amsterdam",
    venue: "IJLAND, TT Vasumweg 171, Amsterdam Noord",
    date: "2026-12-31",
    time: "23:00 – 05:00",
    title: "INDOOR FEST NYE // AMSTERDAM",
    featured: true,
    featured_priority: 1,          // primary homepage spotlight with the countdown
    dress_code: "Dress like you mean it. No such thing as too much shine.",
    tagline: "Three areas, live acts and dancers, and a midnight countdown straight into 2027. Welcome champagne for the first 100 through the door.",
    og_image: "/images/og/og-nye-2026.jpg",
    description: "¡AMSTERDAM, VAMOS A DESPEDIR EL AÑO A LO GRANDE! On December 31st, Baila Dembow takes over IJland in Amsterdam Noord for Indoor Fest NYE, the most glamorous night we’ve ever put together. Three areas, live acts and dancers on stage, and a countdown you’ll still be talking about in February. When the clock hits midnight, the perreo goes to another level, with Bad Bunny, Karol G, El Alfa and Rauw Alejandro carrying us straight into 2027. Dress like you mean it, because tonight there’s no such thing as too much shine. The first 100 people through the door get a welcome glass of champagne on us, so arriving early pays off twice. Early bird tickets are the cheapest you’ll ever see for this night, and every release after that goes up. NYE in Amsterdam sells out fast, so lock yours in while the price is still friendly. 📍 Location: IJland, TT Vasumweg 171, Amsterdam Noord · 🗓️ Date: Thursday, December 31, 2026 · ⏰ Time: 23:00 – 05:00 · 🔞 18+ event, ID required.",
    ticket_url: "https://weeztix.shop/v9f38e5c",
    status: "upcoming",
    price_from: "",
    price_door: "",
    image_url: "/images/events/ijland-nye-dec31-2026.png"
  }
];


// Backward compat alias
export const FALLBACK_EVENTS = EVENTS;

// FAQ — single source of truth for the visible homepage FAQ section.
// Keep the FAQPage JSON-LD in public/index.html in sync with these answers.
export const FAQS = [
  {
    q: "What is the best Latin event in Amsterdam?",
    a: "Baila Dembow is the leading Latin event in Amsterdam and the Netherlands, running sold-out reggaeton and dembow parties since 2023. Over 25,000 fans have joined our events, from club takeovers to the XL editions at IJland and the annual Amsterdam Latin Halloween Festival.",
  },
  {
    q: "Where can I find Latin party events in the Netherlands?",
    a: "Baila Dembow hosts Latin parties across the Netherlands — Amsterdam, Rotterdam, Den Haag, Groningen, Leiden, Eindhoven and beyond. The upcoming agenda includes the Amsterdam Latin Halloween Festival (31 October, IJLAND Amsterdam), Día de Muertos Rotterdam (7 November, Club Reverse), Den Haag at Westwood (21 November), Amsterdam at Supperclub (28 November), Groningen (12 December, Huize Maas) and Indoor Fest NYE (31 December, IJLAND Amsterdam).",
  },
  {
    q: "What is dembow music?",
    a: "Dembow is a high-energy music genre from the Dominican Republic, built on a fast, repetitive riddim that keeps the dancefloor moving. Artists like El Alfa and Rochy RD made it a global sound, and it sits at the heart of every Baila Dembow party alongside reggaeton.",
  },
  {
    q: "Are there reggaeton parties in Amsterdam?",
    a: "Yes — Baila Dembow is Amsterdam's reggaeton party brand, playing Bad Bunny, Karol G, Rauw Alejandro, Daddy Yankee and the full Latin playlist. The next Amsterdam editions are at Oliva on 26 September and the Amsterdam Latin Halloween Festival on 31 October 2026.",
  },
  {
    q: "How much do Baila Dembow tickets cost?",
    a: "Tickets start from around €10 online for early birds and climb in tiers as the event date approaches. Booking early always gets the lowest price — recent editions sold out before the door. Tickets are sold via Weeztix.",
  },
  {
    q: "What is the Amsterdam Latin Halloween Festival by Baila Dembow?",
    a: "The Amsterdam Latin Halloween Festival is Amsterdam's biggest Latin Halloween party — four years running, 1500+ capacity, sold out every time. The whole venue becomes a haunted club with two areas, a cash prize for the best costume and reggaeton, dembow, salsa and bachata until 05:00. The 2026 edition is Saturday 31 October at IJLAND.",
  },
  {
    q: "What are the Live Tribute Shows at Baila Dembow?",
    a: "Live Tribute Shows are special Baila Dembow nights where world-class musicians perform live tributes to Latin legends like Juan Luis Guerra and the salsa and merengue greats. After the live set, our resident DJs take over with reggaeton and dembow until sunrise.",
  },
  {
    q: "What's the door policy at Baila Dembow?",
    a: "No hats — unless the venue says otherwise, so check with them directly. No tracksuits or trainers. And no bags for men on the dancefloor.",
  },
  {
    q: "Are Baila Dembow tickets refundable?",
    a: "Tickets are non-refundable, except if an event is cancelled or postponed for any reason. You're welcome to resell your ticket on TicketSwap or exchange it privately with someone else.",
  },
  {
    q: "What's the minimum age and do I need ID?",
    a: "Minimum age is 18 unless stated otherwise for a specific event, and ID is mandatory. No ID, no entry.",
  },
  {
    q: "What are Baila Dembow's house rules?",
    a: "Treat everyone with respect, whatever their sexual preference, ethnicity or gender. Be quiet and respect our neighbours when you leave, and keep the surrounding area clean. Intolerance, sexism, violence and racism are not tolerated, and outside food, drinks, weapons and hard drugs are not allowed. Look after your own belongings and follow staff instructions at all times.",
  },
  {
    q: "Can I take photos and videos at the event?",
    a: "Yes. By entering a Baila Dembow event, you agree that the organiser can use photos and videos taken there for marketing purposes.",
  },
];

// Halloween-specific FAQ — rendered on /halloween and mirrored as FAQPage
// JSON-LD for that route (see Seo + App.js). Phrased around what people
// actually search: "halloween party amsterdam", "halloween events amsterdam".
export const HALLOWEEN_FAQS = [
  {
    q: "Where is the best Halloween party in Amsterdam?",
    a: "The Amsterdam Latin Halloween Festival by Baila Dembow is Amsterdam's biggest Latin Halloween party: four years running, 1500+ capacity and sold out every time. The 2026 edition is on Saturday 31 October at IJLAND, TT Vasumweg 171, Amsterdam, from 23:00 to 05:00.",
  },
  {
    q: "What Halloween events are on in Amsterdam on 31 October 2026?",
    a: "Amsterdam has Halloween parties in every music style. If you want reggaeton, dembow, salsa and bachata instead of techno, the Amsterdam Latin Halloween Festival at IJLAND is the one: a full haunted club transformation, two areas, a cash prize for the best costume and music until 05:00.",
  },
  {
    q: "When and where is the Amsterdam Latin Halloween Festival?",
    a: "Saturday 31 October 2026, 23:00 to 05:00, at IJLAND, TT Vasumweg 171, Amsterdam.",
  },
  {
    q: "How much are Amsterdam Latin Halloween Festival tickets?",
    a: "The 2026 edition is sold out: no more tickets are available. If you still want to come, only buy from a reputable reseller such as TicketSwap and be aware of fake tickets: never pay strangers by bank transfer. For next year, sign up for the Halloween 2027 early release at bailadembow.com/halloween/2027.",
  },
  {
    q: "What is the dress code, and is there a costume contest?",
    a: "Come in costume. The dress code is Scary, Sexy or Scary-Sexy, and there is a cash prize for the best costume of the night.",
  },
  {
    q: "What is the age limit for the Halloween party?",
    a: "The Amsterdam Latin Halloween Festival is 18+. A valid ID is mandatory: no ID, no entry.",
  },
  {
    q: "What can I expect at the Amsterdam Latin Halloween Festival?",
    a: "A full haunted club transformation, two areas, free trick-and-treat sweets, a spooky photobooth, food trucks on site, and reggaeton, dembow, dancehall, salsa, bachata and merengue from open to close.",
  },
];
